var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.field.type == 'checkbox')?_c('div',{staticClass:"text"},[_c('b-form-group',[_c('b-form-select',{attrs:{"options":_vm.options},on:{"change":_vm.setFilters},model:{value:(_vm.filter.checkbox),callback:function ($$v) {_vm.$set(_vm.filter, "checkbox", $$v)},expression:"filter.checkbox"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }